import ajax from "../custom/ajax";
import map from "../custom/map";

export default {
  init() {
    ajax();
    map();
  },
};
